export enum GridBackgroundColorKeys {
  Orange = 'Orange',
  White = 'White',
  DarkBlue = 'Dark Blue'
}
